import { type ComponentProps, type FC, type ReactNode } from 'react';

import clsx from 'clsx';

import { isSimpleNode } from '@/utils/react';

import styles from './Button.module.scss';

export type ButtonProps = Omit<ComponentProps<'button'>, 'color' | 'children'> & {
  variant?: 'main' | 'secondary' | 'mediumIcon' | 'largeIcon';
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  isActive?: boolean;
  children: ReactNode;
};

export const Button: FC<ButtonProps> = (props) => {
  const {
    className,
    variant = 'main',
    iconLeft,
    iconRight,
    isActive,
    type = 'button',
    children,
    ...buttonProps
  } = props;

  return (
    <button
      className={clsx(styles.root, styles[`variant_${variant}`], { [styles.isActive]: isActive }, className)}
      type={type}
      {...buttonProps}
    >
      {iconLeft}

      {isSimpleNode(children) ? <span>{children}</span> : children}

      {iconRight}
    </button>
  );
};
